/*
* 主题定制
* 方案：https://ant-design.gitee.io/docs/react/customize-theme-cn
* 这里利用了 less-loader 的 modifyVars 来进行主题配置
* 此文件会被 /config/webpack.config.js引用
*
* 注：此文件修改之后，需要重新启动webpack才能生效：yarn start
* */
module.exports = {
    //'@primary-color': '#409EFF',                         // 全局主色
    '@primary-color': '#357ca5',                         // 全局主色
    //'@primary-color': '#00a7d0',                         // 全局主色
    //'@primary-color': '#8aa4af',                         // 全局主色
    '@link-color': '@primary-color',                     // 链接色
    '@success-color': '#52c41a',                         // 成功色
    '@warning-color': '#faad14',                         // 警告色
    '@error-color': '#f56c6c',                           // 错误色
    '@font-size-base': '12px',                           // 主字号
    '@heading-color': '#000000',              // 标题色
    '@text-color': '#000000',                 // 主文本色
    '@text-color-secondary ': '#000000',      // 次文本色
    '@disabled-color ': 'rgba(0, 0, 0, .35)',            // 失效色
    '@border-radius-base': '3px',                        // 组件/浮层圆角
    '@border-color-base': '#d9d9d9',                     // 边框色
    '@box-shadow-base': '0 2px 8px rgba(0, 0, 0, .15)',  // 浮层阴影

    '@layout-header-background': '#001529',              // 深色主题样式
    '@menu-dark-submenu-bg': 'lighten(@layout-header-background, 5%)',

    '@input-height-base': '28px',
    '@input-height-lg': '40px',
    '@input-height-sm': '24px',

    '@btn-height-base': '28px',

    '@table-padding-vertical': '8px',
    '@table-padding-horizontal': '8px',
    '@menu-inline-toplevel-item-height': '30px',
    '@menu-item-height': '30px',
};
